import { ButtonElement, ButtonEvent } from "appworks/graphics/elements/button-element";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { ygg } from "ygg/ygg";

export class PartnerConnectHistoryButtonControl extends AbstractControl {

    constructor(protected button: ButtonElement) {
        super();

        const disabled = PartnerConnectManager.getConfig().customParameters.disableMenuHistory;
        const enabled = PartnerConnectManager.getConfig().settings.isGameHistoryEnabled;

        if (disabled) {
            this.button.visible = false;
        } else if (enabled) {
            this.enableButton();
        }
    }

    public destroy(): void {
        this.button.removeAllListeners();
    }

    protected enableButton(): void {
        this.button.on(ButtonEvent.CLICK, () => ygg.showHistory());
        this.button.visible = true;
    }
}
